export default __webpack_public_path__ + "static/tbc-navbar-d559796625f2923fedd3ce5eb8bb6bc2.png";